<template>
  <el-row class="pb-2" style="border-bottom: 5px solid #f0f0f0">
    <el-col :span="24">
      <el-breadcrumb separator="/" class="py-2">
        <el-breadcrumb-item v-for="(item,index) in items" :key="index" :to="item.href">{{item.text}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
</template>

<script>
export default {
  computed: {
    items() {
      let tempitems = [];
      this.$route.matched.map((item, index) => {
        if (index != 0) {
          tempitems.push({
            text: item.meta.name,
            disabled: index == this.$route.matched.length - 1 ? true : false,
            href: item.path
          });
        }
      });

      return tempitems;
    }
  }
};
</script>
